export class KeyboardAlpha{
    constructor(){
    }
    public shift: boolean = false;
    public mayus: boolean = false;
    public actualKeys = {};
    public defaultKeys = {
        "accent" : "`",
        "1" : "1",
        "2" : "2",
        "3" : "3",
        "4" : "4",
        "5" : "5",
        "6" : "6",
        "7" : "7",
        "8" : "8",
        "9" : "9",
        "0" : "0",
        "hyphen" : "-",
        "equal" : "=",
        "q" : "q",
        "w" : "w",
        "e" : "e",
        "r" : "r",
        "t" : "t",
        "y" : "y",
        "u" : "u",
        "i" : "i",
        "o" : "o",
        "p" : "p",
        "keyL" : "[",
        "keyR" : "]",
        "backslash" : "\\",
        "a" : "a",
        "s" : "s",
        "d" : "d",
        "f" : "f",
        "g" : "g",
        "h" : "h",
        "j" : "j",
        "k" : "k",
        "l" : "l",
        "dot-comma" : ";",
        "cometa-simple" : "'",
        "z" : "z",
        "x" : "x",
        "c" : "c",
        "v" : "v",
        "b" : "b",
        "n" : "n",
        "m" : "m",
        "comma" : ",",
        "dot" : ".",
        "bar" : "/",
    };

    public shiftKeys = {
        "accent" : "~",
        "1" : "!",
        "2" : "@",
        "3" : "#",
        "4" : "$",
        "5" : "%",
        "6" : "^",
        "7" : "&",
        "8" : "*",
        "9" : "(",
        "0" : ")",
        "hyphen" : "_",
        "equal" : "+",
        "q" : "Q",
        "w" : "W",
        "e" : "E",
        "r" : "R",
        "t" : "T",
        "y" : "Y",
        "u" : "U",
        "i" : "I",
        "o" : "O",
        "p" : "P",
        "keyL" : "{",
        "keyR" : "}",
        "backslash" : "|",
        "a" : "A",
        "s" : "S",
        "d" : "D",
        "f" : "F",
        "g" : "G",
        "h" : "H",
        "j" : "J",
        "k" : "K",
        "l" : "L",
        "dot-comma" : ":",
        "cometa-simple" : '"',
        "z" : "Z",
        "x" : "X",
        "c" : "C",
        "v" : "V",
        "b" : "B",
        "n" : "N",
        "m" : "M",
        "comma" : "<",
        "dot" : ">",
        "bar" : "?",
    }
    public setDefaultKeys(){
        this.actualKeys = this.defaultKeys;
    }
    public setShiftKeys(){
        this.actualKeys = this.shiftKeys;
    }
}